import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getSportMatches, GetSportMatchesParams} from '../api/api';
import {SportMatchActivationItem} from '../api/types';

export const useGetSportMatches = <
  SelectedData = GetListOutput<SportMatchActivationItem>,
>(
  categorySlug: string,
  params: GetSportMatchesParams,
  options?: QueryOptionsForList<SportMatchActivationItem, SelectedData>,
) =>
  useQuery({
    queryKey: ['sportMatches', categorySlug, params],
    queryFn: () => getSportMatches(categorySlug, params),
    ...options,
  });
